import fastInternet from "../Images/fastInternet.png"

import mut from "../Images/mut.jpg"
import dut from "../Images/dut.png"
import wikipedia from "../Images/Wikipedia.jpg"
import unisa from "../Images/unisa.png"
import googlePlayBadge from "../Images/GetItOnGooglePlay_Badge_Web_color_English.png"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../CSS/CarouselStyling.css";
import { Carousel } from 'react-responsive-carousel';
import { Col, Container, Row } from "react-bootstrap";
import GreenButton from "./Core/GreenButton";
import GradientButton from "./Core/GradientButton";
import LoginModal from "./Portal/LoginModal";
import { useState } from "react";
import Logo from "./Core/Logo"

export default function LandingPage({ login }) {
	const [showLoginModal, setShowLoginModal] = useState(false);

	function handleLoginClicked() {
		setShowLoginModal(true);
	}

	return 	<Container fluid>
				<div className="d-flex flex-column p-2 p-md-4">
					<Row className="d-flex justify-content-center align-items-center my-4 mb-5">
						<Col xs={12} md={4} lg={2} className="d-flex justify-content-center align-items-center">
							<Logo className="text-center px-0 mx-0" onClick={ e => window.location.assign("https://zingfibre.co.za")}></Logo>
						</Col>
						<Col xs={12} md={4} lg={3} className="mt-3 mt-md-0 d-flex flex-column align-items-center justify-content-center">
							<p className="mb-2 text-center text-primary" >Download our App now!</p>
							<a href="https://play.google.com/store/apps/details?id=za.co.zingfibre.portal" target="_blank" rel="noopener noreferrer">
								<img src={googlePlayBadge} alt="Get it on Google Play" style={{ height: "70px", width: "auto" }} />
							</a>
						</Col>
						<Col xs={12} md={4} lg={3} className="mt-4 mt-md-0 d-flex flex-column align-items-center justify-content-center">
							<GradientButton title="Login" variant="greenYellow" onClick={handleLoginClicked} className="mb-3" />
							<GradientButton title="Sign Up" variant="yellowOrange" onClick={() => { window.location.hash = "/Register/Welcome"; }} />
						</Col>
					</Row>
					<Row>
						<Col className="offset-0 offset-lg-2" lg={ 8 } xs={ 12 } style={{ borderRadius:"32px" }}>
							<Carousel className="rounded-border" autoPlay infiniteLoop showArrows={ false } showThumbs={ false } showIndicators={ false } showStatus={ false }>
								<div>
									<img style={{ width: "60%" }} src={ fastInternet } />
								</div>
							</Carousel>
						</Col>
					</Row>
					<div className="d-flex flex-column mt-5">
						<div><h3 className="text-center pb-3">Access Free Websites Below</h3></div>
						<Row className="d-flex justify-content-center align-items-center">
							<Col md={4} lg={2} className="d-flex justify-content-center align-items-center">
								<GreenButton onClick={ e => window.open("https://www.mut.ac.za/", '_blank').focus() }><img style={{ height: "60px" }} src={ mut }></img></GreenButton>
							</Col>
							<Col md={4} lg={2} className="d-flex justify-content-center align-items-center">
								<GreenButton onClick={ e => window.open("https://www.dut.ac.za/", '_blank').focus() }><img style={{ height: "60px" }} src={ dut }></img></GreenButton>
							</Col>
							<Col md={4} lg={2} className="d-flex justify-content-center align-items-center">
								<GreenButton onClick={ e => window.open("https://www.unisa.ac.za/", '_blank').focus() }><img src={ unisa } style={{ height: "75px" }}></img></GreenButton>
							</Col>
							<Col md={4} lg={2} className="d-flex justify-content-center align-items-center">
								<GreenButton onClick={ e => window.open("https://en.wikipedia.org/wiki/Main_Page", '_blank').focus() }><img src={ wikipedia } style={{ height: "72px" }}></img></GreenButton>
							</Col>
						</Row>
					</div>
					<LoginModal show={showLoginModal} onClose={() => setShowLoginModal(false)} />
				</div>
			</Container>
}